import React from 'react';
import FocusedExerciseView from '../../focused_view/FocusedExerciseView';

const AttemptMainContent = ({ exercise, attemptId, isReviewMode, showHint, fillHintSignal, isFitMode, zoomLevel, sharedColor, setSharedColor }) => {
  if (!exercise) {
    return <div className="exam-attempt-container"><p>Loading Exercise...</p></div>;
  }

  return (
    <div key={exercise.id} className="animate-fade-in flex-1 flex flex-col w-full min-h-0">
      <FocusedExerciseView
        exercise={exercise}
        attemptId={attemptId}
        isReviewMode={isReviewMode}
        showHint={showHint}
        fillHintSignal={fillHintSignal}
        zoomLevel={zoomLevel}
        sharedColor={sharedColor}
        setSharedColor={setSharedColor}
      />
    </div>
  );
};

export default AttemptMainContent;
